import { Box, Button, LinearProgress, Menu, MenuItem } from "@mui/material";
import { useState, useRef, useEffect, useContext } from "react";
import prof from "../Images/m header.png";
import { useHistory, useLocation } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import BreadCrumbs from "./BreadCrumbs";
import coldMailLogo from "../Images/coldemail.svg";
import BaseUrl from "../BaseUrl";
import axios from "axios";
import Modal from "@mui/material/Modal";
import Pricing from "./Pricing";
import Context from "../Contex/Context";
export default function CommonComponant({ Componant, open3, setOpen3 }) {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const history = useHistory();
  const location = useLocation();
  const [searchedVal, setSearchedVal] = useState("");
  const [open2, setOpen2] = useState(false);
  const [subSideBarItem, setSubSideBarItem] = useState([]);
  const divRef = useRef(null);
  const [selected, setSelected] = useState(0);
  const [defaultActivePathIndex, setDefaultActivePathIndex] = useState(1);
  const [open, setOpen] = useState(false);
  const [selectedSub, setSelectedSub] = useState();
  const [filterDefaultValue, setFilterDefaultValue] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const MenuOpen = Boolean(anchorEl);
  const [allInvite, setAllInvite] = useState([]);
  const { setUserPlanInformation, setCurrentPlan, currentPlan } =
    useContext(Context);

  function getAllIntegration() {
    const userDetailsFrom = JSON.parse(
      localStorage.getItem("MailSenderuserDetails")
    );
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/get-user-info-by-id/${
          userDetailsFrom && userDetailsFrom.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${
              userDetailsFrom && userDetailsFrom.token
            }`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
        } else {
          localStorage.removeItem("MailSenderuserDetails");
          window.location.reload();
        }
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getAllIntegration();
  }, []);
  useEffect(() => {
    if (
      location.pathname === "/Email/accounts" ||
      location.pathname === "/Email/accounts/settings"
    ) {
      setDefaultActivePathIndex(1);
    } else if (
      location.pathname === "/DashBoard/Campaign" ||
      location.pathname === "/All-Campaign/Templates" ||
      location.pathname === "/All-Campaign/New-Campaign" ||
      location.pathname === "/Statistics" ||
      location.pathname === "/statistics"
    ) {
      setDefaultActivePathIndex(3);
    } else if (location.pathname === "/All-Campaign/Schedule") {
      setDefaultActivePathIndex(5);
    } else if (
      location.pathname === "/EmailVerify" ||
      location.pathname === "/BulkMailVerification"
    ) {
      setDefaultActivePathIndex(6);
    } else if (
      location.pathname === "/Contacts" ||
      location.pathname === "/Lists" ||
      location.pathname.includes("/Contacts")
    ) {
      setDefaultActivePathIndex(2);
    } else if (location.pathname === "/Replies") {
      setDefaultActivePathIndex(4);
    } else if (
      location.pathname === "/Goals" ||
      location.pathname.includes("/Goals/") ||
      location.pathname.includes("/Goal/leads/")
    ) {
      setDefaultActivePathIndex(7);
    } else if (
      location.pathname === "/Accounts" ||
      location.pathname.includes("/Accounts/") ||
      location.pathname.includes("/api/documentation/")
    ) {
      setDefaultActivePathIndex(10);
    } else if (
      location.pathname === "/Pricing" ||
      location.pathname === "/pricing"
    ) {
      setDefaultActivePathIndex(9);
    } else if (
      location.pathname === "/integrations" ||
      location.pathname === "/Integrations"
    ) {
      setDefaultActivePathIndex(8);
    }
  }, [location.pathname]);
  useEffect(() => {
    getUserCurrentPlan();
  }, []);

  function getUserCurrentPlan() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/get-user-current-plan/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setCurrentPlan(response.data);
          setUserPlanInformation(response.data.user.Api_Key);
        } else {
          // setOpen2(true);
          setCurrentPlan([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseFilterMenu = () => {
    setAnchorEl(null);
  };

  const sidebarItems = [
    {
      pathIndex: 1,
      name: "Email Accounts",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M9.99935 17.0834H5.83268C3.33268 17.0834 1.66602 15.8334 1.66602 12.9167V7.08341C1.66602 4.16675 3.33268 2.91675 5.83268 2.91675H14.166C16.666 2.91675 18.3327 4.16675 18.3327 7.08341V9.58342"
            stroke="#868686"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.1673 7.5L11.559 9.58333C10.7006 10.2667 9.29231 10.2667 8.43398 9.58333L5.83398 7.5"
            stroke="#868686"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.1667 17.8333C16.6394 17.8333 17.8333 16.6394 17.8333 15.1667C17.8333 13.6939 16.6394 12.5 15.1667 12.5C13.6939 12.5 12.5 13.6939 12.5 15.1667C12.5 16.6394 13.6939 17.8333 15.1667 17.8333Z"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.3333 18.3333L17.5 17.5"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M9.99935 17.0834H5.83268C3.33268 17.0834 1.66602 15.8334 1.66602 12.9167V7.08341C1.66602 4.16675 3.33268 2.91675 5.83268 2.91675H14.166C16.666 2.91675 18.3327 4.16675 18.3327 7.08341V9.58342"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.1673 7.5L11.559 9.58333C10.7006 10.2667 9.29231 10.2667 8.43398 9.58333L5.83398 7.5"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.1667 17.8333C16.6394 17.8333 17.8333 16.6394 17.8333 15.1667C17.8333 13.6939 16.6394 12.5 15.1667 12.5C13.6939 12.5 12.5 13.6939 12.5 15.1667C12.5 16.6394 13.6939 17.8333 15.1667 17.8333Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.3333 18.3333L17.5 17.5"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    {
      pathIndex: 2,
      name: "Lists",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M7.63334 9.05832C7.55 9.04999 7.45 9.04999 7.35834 9.05832C5.375 8.99166 3.8 7.36666 3.8 5.36666C3.8 3.32499 5.45 1.66666 7.5 1.66666C9.54167 1.66666 11.2 3.32499 11.2 5.36666C11.1917 7.36666 9.61667 8.99166 7.63334 9.05832Z"
            stroke="#727272"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.675 3.33334C15.2917 3.33334 16.5917 4.64168 16.5917 6.25001C16.5917 7.82501 15.3417 9.10834 13.7833 9.16668C13.7167 9.15834 13.6417 9.15834 13.5667 9.16668"
            stroke="#727272"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.46666 12.1333C1.45 13.4833 1.45 15.6833 3.46666 17.025C5.75833 18.5583 9.51666 18.5583 11.8083 17.025C13.825 15.675 13.825 13.475 11.8083 12.1333C9.525 10.6083 5.76666 10.6083 3.46666 12.1333Z"
            stroke="#727272"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.2833 16.6667C15.8833 16.5417 16.45 16.3 16.9167 15.9417C18.2167 14.9667 18.2167 13.3583 16.9167 12.3833C16.4583 12.0333 15.9 11.8 15.3083 11.6667"
            stroke="#727272"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M7.63334 9.05832C7.55 9.04999 7.45 9.04999 7.35834 9.05832C5.375 8.99166 3.8 7.36666 3.8 5.36666C3.8 3.32499 5.45 1.66666 7.5 1.66666C9.54167 1.66666 11.2 3.32499 11.2 5.36666C11.1917 7.36666 9.61667 8.99166 7.63334 9.05832Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.675 3.33334C15.2917 3.33334 16.5917 4.64168 16.5917 6.25001C16.5917 7.82501 15.3417 9.10834 13.7833 9.16668C13.7167 9.15834 13.6417 9.15834 13.5667 9.16668"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.46666 12.1333C1.45 13.4833 1.45 15.6833 3.46666 17.025C5.75833 18.5583 9.51666 18.5583 11.8083 17.025C13.825 15.675 13.825 13.475 11.8083 12.1333C9.525 10.6083 5.76666 10.6083 3.46666 12.1333Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.2833 16.6667C15.8833 16.5417 16.45 16.3 16.9167 15.9417C18.2167 14.9667 18.2167 13.3583 16.9167 12.3833C16.4583 12.0333 15.9 11.8 15.3083 11.6667"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    {
      pathIndex: 3,
      name: "Campaigns",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M1.66667 7.08332C1.66667 4.16666 3.33334 2.91666 5.83334 2.91666H14.1667C16.6667 2.91666 18.3333 4.16666 18.3333 7.08332V12.9167C18.3333 15.8333 16.6667 17.0833 14.1667 17.0833H5.83334"
            stroke="#727272"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.1667 7.5L11.5583 9.58333C10.7 10.2667 9.29166 10.2667 8.43332 9.58333L5.83333 7.5"
            stroke="#727272"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.66667 13.75H6.66667"
            stroke="#727272"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.66667 10.4167H4.16667"
            stroke="#727272"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M1.66663 7.08332C1.66663 4.16666 3.33329 2.91666 5.83329 2.91666H14.1666C16.6666 2.91666 18.3333 4.16666 18.3333 7.08332V12.9167C18.3333 15.8333 16.6666 17.0833 14.1666 17.0833H5.83329"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.1667 7.5L11.5584 9.58333C10.7 10.2667 9.2917 10.2667 8.43337 9.58333L5.83337 7.5"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.66663 13.75H6.66663"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.66663 10.4167H4.16663"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    {
      pathIndex: 4,
      name: "Replies",
      svg: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.56489 0.359865C8.45756 0.359536 8.35351 0.396826 8.27083 0.465253C8.18815 0.533681 8.13206 0.628919 8.11231 0.734413L7.8415 2.19772C7.43023 2.32624 7.03181 2.48689 6.64992 2.68518L5.43356 1.84796C5.34447 1.78695 5.23673 1.75931 5.12927 1.76989C5.02181 1.78046 4.92152 1.82859 4.84604 1.90579L2.8255 3.97131C2.75127 4.04725 2.70567 4.14657 2.69646 4.25237C2.68726 4.35816 2.71502 4.46387 2.77501 4.55149L3.60122 5.75867C3.39596 6.15446 3.22697 6.56803 3.09632 6.99431L1.65504 7.26604C1.54938 7.28559 1.45393 7.3416 1.38532 7.4243C1.31671 7.50701 1.27929 7.61116 1.27958 7.71861V8.69354C1.2792 8.70425 1.2792 8.71496 1.27958 8.72567V19.1809C1.27958 19.3026 1.32794 19.4193 1.41402 19.5054C1.5001 19.5915 1.61685 19.6399 1.73858 19.6399H18.2572C18.3789 19.6399 18.4957 19.5915 18.5818 19.5054C18.6679 19.4193 18.7162 19.3026 18.7162 19.1809V9.15989C18.7212 9.12894 18.7231 9.09757 18.7217 9.06625V7.71861C18.7221 7.61129 18.6848 7.50724 18.6163 7.42456C18.5479 7.34188 18.4527 7.28578 18.3472 7.26604L16.9059 6.99431C16.775 6.568 16.6057 6.15443 16.4001 5.75867L17.2263 4.55149C17.2863 4.46387 17.314 4.35816 17.3048 4.25237C17.2956 4.14657 17.25 4.04725 17.1758 3.97131L15.1562 1.90579C15.0806 1.82835 14.9802 1.78008 14.8725 1.7695C14.7648 1.75892 14.6569 1.78671 14.5677 1.84796L13.3514 2.68518C12.9695 2.48758 12.5707 2.32444 12.1598 2.19772L11.889 0.734413C11.8692 0.628919 11.8132 0.533681 11.7305 0.465253C11.6478 0.396826 11.5437 0.359536 11.4364 0.359865H8.56489ZM8.94678 1.27787H11.0545L11.3005 2.60623C11.3165 2.69102 11.3561 2.76959 11.4147 2.83292C11.4734 2.89624 11.5486 2.94176 11.6319 2.96425C12.1828 3.11389 12.7115 3.32319 13.1815 3.59768C13.2567 3.64149 13.3428 3.66302 13.4298 3.65977C13.5167 3.65652 13.601 3.62862 13.6727 3.57932L14.7697 2.8238L16.2569 4.34402L15.505 5.4392C15.456 5.51062 15.4281 5.59448 15.4247 5.68107C15.4213 5.76765 15.4424 5.85344 15.4857 5.9285C15.7714 6.42683 15.9897 6.96088 16.1348 7.51665C16.1567 7.60105 16.2021 7.67748 16.2658 7.73698C16.3296 7.79648 16.4089 7.8366 16.4946 7.85264L17.8037 8.09867V8.63295L14.0399 8.62744C13.804 6.57386 12.1157 4.9499 10.0006 4.9499C7.88281 4.9499 6.19275 6.57753 5.95958 8.63479L2.19759 8.64213V8.09867L3.50666 7.85264C3.59225 7.83667 3.67153 7.79669 3.73525 7.73736C3.79896 7.67803 3.84449 7.6018 3.86652 7.51757C4.01524 6.95483 4.23373 6.41596 4.51555 5.92942C4.55904 5.85425 4.58032 5.76829 4.5769 5.68152C4.57349 5.59475 4.54553 5.51072 4.49628 5.4392L3.74535 4.34402L5.2316 2.8238L6.32862 3.58024C6.40032 3.62954 6.48457 3.65744 6.57152 3.66069C6.65848 3.66394 6.74457 3.64241 6.81975 3.5986C7.30612 3.3201 7.82716 3.10711 8.36935 2.96517C8.45266 2.94268 8.52794 2.89716 8.58655 2.83383C8.64517 2.77051 8.68475 2.69194 8.70075 2.60715L8.94678 1.27787ZM10.0006 5.86791C11.6191 5.86791 12.8933 7.07234 13.1219 8.62561L10.0025 8.62193C10.0019 8.62193 10.0013 8.62193 10.0006 8.62193V8.62561L6.87759 8.63295C7.1025 7.07601 8.37945 5.86791 10.0006 5.86791ZM10.0006 9.54361H10.0025L16.7517 9.55279L10.0006 14.0584L3.25146 9.5583L10.0006 9.54361ZM17.7982 9.95396V18.7219H2.19759V9.95947L9.74636 14.992C9.82189 15.0425 9.9107 15.0695 10.0016 15.0695C10.0924 15.0695 10.1812 15.0425 10.2568 14.992L17.7982 9.95396Z"
            fill="#727272"
          />
        </svg>
      ),
      activeSvg: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.56489 0.359865C8.45756 0.359536 8.35351 0.396826 8.27083 0.465253C8.18815 0.533681 8.13206 0.628919 8.11231 0.734413L7.8415 2.19772C7.43023 2.32624 7.03181 2.48689 6.64992 2.68518L5.43356 1.84796C5.34447 1.78695 5.23673 1.75931 5.12927 1.76989C5.02181 1.78046 4.92152 1.82859 4.84604 1.90579L2.8255 3.97131C2.75127 4.04725 2.70567 4.14657 2.69646 4.25237C2.68726 4.35816 2.71502 4.46387 2.77501 4.55149L3.60122 5.75867C3.39596 6.15446 3.22697 6.56803 3.09632 6.99431L1.65504 7.26604C1.54938 7.28559 1.45393 7.3416 1.38532 7.4243C1.31671 7.50701 1.27929 7.61116 1.27958 7.71861V8.69354C1.2792 8.70425 1.2792 8.71496 1.27958 8.72567V19.1809C1.27958 19.3026 1.32794 19.4193 1.41402 19.5054C1.5001 19.5915 1.61685 19.6399 1.73858 19.6399H18.2572C18.3789 19.6399 18.4957 19.5915 18.5818 19.5054C18.6679 19.4193 18.7162 19.3026 18.7162 19.1809V9.15989C18.7212 9.12894 18.7231 9.09757 18.7217 9.06625V7.71861C18.7221 7.61129 18.6848 7.50724 18.6163 7.42456C18.5479 7.34188 18.4527 7.28578 18.3472 7.26604L16.9059 6.99431C16.775 6.568 16.6057 6.15443 16.4001 5.75867L17.2263 4.55149C17.2863 4.46387 17.314 4.35816 17.3048 4.25237C17.2956 4.14657 17.25 4.04725 17.1758 3.97131L15.1562 1.90579C15.0806 1.82835 14.9802 1.78008 14.8725 1.7695C14.7648 1.75892 14.6569 1.78671 14.5677 1.84796L13.3514 2.68518C12.9695 2.48758 12.5707 2.32444 12.1598 2.19772L11.889 0.734413C11.8692 0.628919 11.8132 0.533681 11.7305 0.465253C11.6478 0.396826 11.5437 0.359536 11.4364 0.359865H8.56489ZM8.94678 1.27787H11.0545L11.3005 2.60623C11.3165 2.69102 11.3561 2.76959 11.4147 2.83292C11.4734 2.89624 11.5486 2.94176 11.6319 2.96425C12.1828 3.11389 12.7115 3.32319 13.1815 3.59768C13.2567 3.64149 13.3428 3.66302 13.4298 3.65977C13.5167 3.65652 13.601 3.62862 13.6727 3.57932L14.7697 2.8238L16.2569 4.34402L15.505 5.4392C15.456 5.51062 15.4281 5.59448 15.4247 5.68107C15.4213 5.76765 15.4424 5.85344 15.4857 5.9285C15.7714 6.42683 15.9897 6.96088 16.1348 7.51665C16.1567 7.60105 16.2021 7.67748 16.2658 7.73698C16.3296 7.79648 16.4089 7.8366 16.4946 7.85264L17.8037 8.09867V8.63295L14.0399 8.62744C13.804 6.57386 12.1157 4.9499 10.0006 4.9499C7.88281 4.9499 6.19275 6.57753 5.95958 8.63479L2.19759 8.64213V8.09867L3.50666 7.85264C3.59225 7.83667 3.67153 7.79669 3.73525 7.73736C3.79896 7.67803 3.84449 7.6018 3.86652 7.51757C4.01524 6.95483 4.23373 6.41596 4.51555 5.92942C4.55904 5.85425 4.58032 5.76829 4.5769 5.68152C4.57349 5.59475 4.54553 5.51072 4.49628 5.4392L3.74535 4.34402L5.2316 2.8238L6.32862 3.58024C6.40032 3.62954 6.48457 3.65744 6.57152 3.66069C6.65848 3.66394 6.74457 3.64241 6.81975 3.5986C7.30612 3.3201 7.82716 3.10711 8.36935 2.96517C8.45266 2.94268 8.52794 2.89716 8.58655 2.83383C8.64517 2.77051 8.68475 2.69194 8.70075 2.60715L8.94678 1.27787ZM10.0006 5.86791C11.6191 5.86791 12.8933 7.07234 13.1219 8.62561L10.0025 8.62193C10.0019 8.62193 10.0013 8.62193 10.0006 8.62193V8.62561L6.87759 8.63295C7.1025 7.07601 8.37945 5.86791 10.0006 5.86791ZM10.0006 9.54361H10.0025L16.7517 9.55279L10.0006 14.0584L3.25146 9.5583L10.0006 9.54361ZM17.7982 9.95396V18.7219H2.19759V9.95947L9.74636 14.992C9.82189 15.0425 9.9107 15.0695 10.0016 15.0695C10.0924 15.0695 10.1812 15.0425 10.2568 14.992L17.7982 9.95396Z"
            fill="#1C485F"
          />
        </svg>
      ),
    },
    {
      pathIndex: 5,
      name: "Schedules",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M8 2V5"
            stroke="#727272"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16 2V5"
            stroke="#727272"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.5 9.08984H20.5"
            stroke="#727272"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
            stroke="#727272"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.9955 13.7002H12.0045"
            stroke="#727272"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.29431 13.7002H8.30329"
            stroke="#727272"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.29431 16.7002H8.30329"
            stroke="#727272"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M8 2V5"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16 2V5"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.5 9.08984H20.5"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.9955 13.7002H12.0045"
            stroke="#1C485F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.29431 13.7002H8.30329"
            stroke="#1C485F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.29431 16.7002H8.30329"
            stroke="#1C485F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    {
      pathIndex: 6,
      name: "Verification",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M8.38086 12.0001L10.7909 14.4201L15.6209 9.58008"
            stroke="#727272"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.7509 2.45007C11.4409 1.86007 12.5709 1.86007 13.2709 2.45007L14.8509 3.81007C15.1509 4.07007 15.7109 4.28007 16.1109 4.28007H17.8109C18.8709 4.28007 19.7409 5.15007 19.7409 6.21007V7.91007C19.7409 8.30007 19.9509 8.87007 20.2109 9.17007L21.5709 10.7501C22.1609 11.4401 22.1609 12.5701 21.5709 13.2701L20.2109 14.8501C19.9509 15.1501 19.7409 15.7101 19.7409 16.1101V17.8101C19.7409 18.8701 18.8709 19.7401 17.8109 19.7401H16.1109C15.7209 19.7401 15.1509 19.9501 14.8509 20.2101L13.2709 21.5701C12.5809 22.1601 11.4509 22.1601 10.7509 21.5701L9.17086 20.2101C8.87086 19.9501 8.31086 19.7401 7.91086 19.7401H6.18086C5.12086 19.7401 4.25086 18.8701 4.25086 17.8101V16.1001C4.25086 15.7101 4.04086 15.1501 3.79086 14.8501L2.44086 13.2601C1.86086 12.5701 1.86086 11.4501 2.44086 10.7601L3.79086 9.17007C4.04086 8.87007 4.25086 8.31007 4.25086 7.92007V6.20007C4.25086 5.14007 5.12086 4.27007 6.18086 4.27007H7.91086C8.30086 4.27007 8.87086 4.06007 9.17086 3.80007L10.7509 2.45007Z"
            stroke="#727272"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M8.38086 12.0001L10.7909 14.4201L15.6209 9.58008"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.7509 2.45007C11.4409 1.86007 12.5709 1.86007 13.2709 2.45007L14.8509 3.81007C15.1509 4.07007 15.7109 4.28007 16.1109 4.28007H17.8109C18.8709 4.28007 19.7409 5.15007 19.7409 6.21007V7.91007C19.7409 8.30007 19.9509 8.87007 20.2109 9.17007L21.5709 10.7501C22.1609 11.4401 22.1609 12.5701 21.5709 13.2701L20.2109 14.8501C19.9509 15.1501 19.7409 15.7101 19.7409 16.1101V17.8101C19.7409 18.8701 18.8709 19.7401 17.8109 19.7401H16.1109C15.7209 19.7401 15.1509 19.9501 14.8509 20.2101L13.2709 21.5701C12.5809 22.1601 11.4509 22.1601 10.7509 21.5701L9.17086 20.2101C8.87086 19.9501 8.31086 19.7401 7.91086 19.7401H6.18086C5.12086 19.7401 4.25086 18.8701 4.25086 17.8101V16.1001C4.25086 15.7101 4.04086 15.1501 3.79086 14.8501L2.44086 13.2601C1.86086 12.5701 1.86086 11.4501 2.44086 10.7601L3.79086 9.17007C4.04086 8.87007 4.25086 8.31007 4.25086 7.92007V6.20007C4.25086 5.14007 5.12086 4.27007 6.18086 4.27007H7.91086C8.30086 4.27007 8.87086 4.06007 9.17086 3.80007L10.7509 2.45007Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    {
      pathIndex: 7,
      name: "Goals",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M3.54688 9.18255V13.3242C3.54688 14.8409 3.54687 14.8409 4.98021 15.8076L8.92188 18.0826C9.51354 18.4242 10.4802 18.4242 11.0719 18.0826L15.0135 15.8076C16.4469 14.8409 16.4469 14.8409 16.4469 13.3242V9.18255C16.4469 7.66589 16.4469 7.66589 15.0135 6.69922L11.0719 4.42422C10.4802 4.08255 9.51354 4.08255 8.92188 4.42422L4.98021 6.69922C3.54687 7.66589 3.54688 7.66589 3.54688 9.18255Z"
            stroke="#727272"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.5807 6.35964V4.16797C14.5807 2.5013 13.7474 1.66797 12.0807 1.66797H7.91406C6.2474 1.66797 5.41406 2.5013 5.41406 4.16797V6.3013"
            stroke="#727272"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.5264 9.15781L11.0014 9.89948C11.0764 10.0161 11.2431 10.1328 11.3681 10.1661L12.2181 10.3828C12.7431 10.5161 12.8848 10.9661 12.5431 11.3828L11.9848 12.0578C11.9014 12.1661 11.8348 12.3578 11.8431 12.4911L11.8931 13.3661C11.9264 13.9078 11.5431 14.1828 11.0431 13.9828L10.2264 13.6578C10.1014 13.6078 9.89311 13.6078 9.76811 13.6578L8.95144 13.9828C8.45144 14.1828 8.06811 13.8995 8.10144 13.3661L8.15144 12.4911C8.15978 12.3578 8.09311 12.1578 8.00978 12.0578L7.45144 11.3828C7.10978 10.9661 7.25144 10.5161 7.77644 10.3828L8.62644 10.1661C8.75978 10.1328 8.92644 10.0078 8.99311 9.89948L9.46811 9.15781C9.76811 8.70781 10.2348 8.70781 10.5264 9.15781Z"
            stroke="#727272"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M3.54688 9.18255V13.3242C3.54688 14.8409 3.54687 14.8409 4.98021 15.8076L8.92188 18.0826C9.51354 18.4242 10.4802 18.4242 11.0719 18.0826L15.0135 15.8076C16.4469 14.8409 16.4469 14.8409 16.4469 13.3242V9.18255C16.4469 7.66589 16.4469 7.66589 15.0135 6.69922L11.0719 4.42422C10.4802 4.08255 9.51354 4.08255 8.92188 4.42422L4.98021 6.69922C3.54687 7.66589 3.54688 7.66589 3.54688 9.18255Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.5807 6.35964V4.16797C14.5807 2.5013 13.7474 1.66797 12.0807 1.66797H7.91406C6.2474 1.66797 5.41406 2.5013 5.41406 4.16797V6.3013"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.5264 9.15781L11.0014 9.89948C11.0764 10.0161 11.2431 10.1328 11.3681 10.1661L12.2181 10.3828C12.7431 10.5161 12.8848 10.9661 12.5431 11.3828L11.9848 12.0578C11.9014 12.1661 11.8348 12.3578 11.8431 12.4911L11.8931 13.3661C11.9264 13.9078 11.5431 14.1828 11.0431 13.9828L10.2264 13.6578C10.1014 13.6078 9.89311 13.6078 9.76811 13.6578L8.95144 13.9828C8.45144 14.1828 8.06811 13.8995 8.10144 13.3661L8.15144 12.4911C8.15978 12.3578 8.09311 12.1578 8.00978 12.0578L7.45144 11.3828C7.10978 10.9661 7.25144 10.5161 7.77644 10.3828L8.62644 10.1661C8.75978 10.1328 8.92644 10.0078 8.99311 9.89948L9.46811 9.15781C9.76811 8.70781 10.2348 8.70781 10.5264 9.15781Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    {
      pathIndex: 8,
      name: "Integrations",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 21"
          fill="none"
        >
          <path
            d="M18.3333 7.85244V4.48577C18.3333 3.16077 17.8 2.62744 16.475 2.62744H13.1083C11.7833 2.62744 11.25 3.16077 11.25 4.48577V7.85244C11.25 9.17744 11.7833 9.71078 13.1083 9.71078H16.475C17.8 9.71078 18.3333 9.17744 18.3333 7.85244Z"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.74935 8.06077V4.27744C8.74935 3.10244 8.21602 2.62744 6.89102 2.62744H3.52435C2.19935 2.62744 1.66602 3.10244 1.66602 4.27744V8.05244C1.66602 9.23577 2.19935 9.70244 3.52435 9.70244H6.89102C8.21602 9.71077 8.74935 9.23577 8.74935 8.06077Z"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.74935 17.4357V14.069C8.74935 12.744 8.21602 12.2107 6.89102 12.2107H3.52435C2.19935 12.2107 1.66602 12.744 1.66602 14.069V17.4357C1.66602 18.7607 2.19935 19.294 3.52435 19.294H6.89102C8.21602 19.294 8.74935 18.7607 8.74935 17.4357Z"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.084 15.5439H17.084"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M14.584 18.0439V13.0439"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 21"
          fill="none"
        >
          <path
            d="M18.3333 7.85244V4.48577C18.3333 3.16077 17.8 2.62744 16.475 2.62744H13.1083C11.7833 2.62744 11.25 3.16077 11.25 4.48577V7.85244C11.25 9.17744 11.7833 9.71078 13.1083 9.71078H16.475C17.8 9.71078 18.3333 9.17744 18.3333 7.85244Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.74935 8.06077V4.27744C8.74935 3.10244 8.21602 2.62744 6.89102 2.62744H3.52435C2.19935 2.62744 1.66602 3.10244 1.66602 4.27744V8.05244C1.66602 9.23577 2.19935 9.70244 3.52435 9.70244H6.89102C8.21602 9.71077 8.74935 9.23577 8.74935 8.06077Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.74935 17.4357V14.069C8.74935 12.744 8.21602 12.2107 6.89102 12.2107H3.52435C2.19935 12.2107 1.66602 12.744 1.66602 14.069V17.4357C1.66602 18.7607 2.19935 19.294 3.52435 19.294H6.89102C8.21602 19.294 8.74935 18.7607 8.74935 17.4357Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.084 15.5439H17.084"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M14.584 18.0439V13.0439"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      ),
    },
    {
      pathIndex: 9,
      name: "Plans",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M18.3327 9.99967V14.1663C18.3327 16.6663 16.666 18.333 14.166 18.333H5.83268C3.33268 18.333 1.66602 16.6663 1.66602 14.1663V9.99967C1.66602 7.73301 3.03268 6.14967 5.15768 5.88301C5.37435 5.84967 5.59935 5.83301 5.83268 5.83301H14.166C14.3827 5.83301 14.591 5.84133 14.791 5.87466C16.941 6.12466 18.3327 7.71634 18.3327 9.99967Z"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.7935 5.87532C14.5935 5.84199 14.3852 5.83367 14.1685 5.83367H5.83516C5.60182 5.83367 5.37682 5.85033 5.16016 5.88367C5.27682 5.65033 5.44349 5.43367 5.64349 5.23367L8.35182 2.51699C9.49349 1.38366 11.3435 1.38366 12.4852 2.51699L13.9435 3.99201C14.4768 4.51701 14.7602 5.18366 14.7935 5.87532Z"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.3327 10.417H15.8327C14.916 10.417 14.166 11.167 14.166 12.0837C14.166 13.0003 14.916 13.7503 15.8327 13.7503H18.3327"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M18.3327 9.99967V14.1663C18.3327 16.6663 16.666 18.333 14.166 18.333H5.83268C3.33268 18.333 1.66602 16.6663 1.66602 14.1663V9.99967C1.66602 7.73301 3.03268 6.14967 5.15768 5.88301C5.37435 5.84967 5.59935 5.83301 5.83268 5.83301H14.166C14.3827 5.83301 14.591 5.84133 14.791 5.87466C16.941 6.12466 18.3327 7.71634 18.3327 9.99967Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.7935 5.87532C14.5935 5.84199 14.3852 5.83367 14.1685 5.83367H5.83516C5.60182 5.83367 5.37682 5.85033 5.16016 5.88367C5.27682 5.65033 5.44349 5.43367 5.64349 5.23367L8.35182 2.51699C9.49349 1.38366 11.3435 1.38366 12.4852 2.51699L13.9435 3.99201C14.4768 4.51701 14.7602 5.18366 14.7935 5.87532Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.3327 10.417H15.8327C14.916 10.417 14.166 11.167 14.166 12.0837C14.166 13.0003 14.916 13.7503 15.8327 13.7503H18.3327"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    {
      pathIndex: 10,
      name: "Profile",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10.0007 10.0003C12.3018 10.0003 14.1673 8.13485 14.1673 5.83366C14.1673 3.53247 12.3018 1.66699 10.0007 1.66699C7.69946 1.66699 5.83398 3.53247 5.83398 5.83366C5.83398 8.13485 7.69946 10.0003 10.0007 10.0003Z"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.1585 18.3333C17.1585 15.1083 13.9501 12.5 10.0001 12.5C6.05013 12.5 2.8418 15.1083 2.8418 18.3333"
            stroke="#868686"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10.0007 10.0003C12.3018 10.0003 14.1673 8.13485 14.1673 5.83366C14.1673 3.53247 12.3018 1.66699 10.0007 1.66699C7.69946 1.66699 5.83398 3.53247 5.83398 5.83366C5.83398 8.13485 7.69946 10.0003 10.0007 10.0003Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.1585 18.3333C17.1585 15.1083 13.9501 12.5 10.0001 12.5C6.05013 12.5 2.8418 15.1083 2.8418 18.3333"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
  ];
  const subSideBar2 = [
    {
      id: 1,
      path: "/DashBoard/Campaign",
      value: "All Campaign",
    },
    {
      id: 2,
      path: "/All-Campaign/New-Campaign",
      value: "New Campaign",
    },
    {
      id: 3,
      path: "/All-Campaign/Templates",
      value: "Templates",
    },
    {
      id: 4,
      path: "/All-Campaign/Schedule",
      value: "Schedules",
    },
  ];
  const subAccountSidebar2 = [
    { id: 1, path: "/Contacts", value: "All Contacts" },
    { id: 2, path: "/Lists", value: "Lists" },
  ];
  const verifySidebar2 = [
    { id: 1, path: "/Emailverify", value: "Individual Email Verification" },
    { id: 2, path: "/BulkMailVerification", value: "Bulk Email Verification" },
  ];
  const warmupOptions2 = [
    { id: 1, path: "/AllMailWarmUp", value: "All Warm-Ups" },
    { id: 2, path: "/MailWarmUp", value: "Warm-Up" },
  ];
  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const fullName = userDetails && userDetails.details.FirstName;
  const nameArray = fullName && fullName.split(" ");
  const initials = nameArray && nameArray.map((word) => word.charAt(0));
  const initialsString = initials && initials.join("");

  return (
    <>
      <div className="wholeDashboard" style={{ height: "100vh" }}>
        {/* left side content */}
        <div
          //  ref={divRef}
          className="sidebarDashboard"
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              height: "100%",
              overflowY: "scroll",
              position: "relative",
              width: "100px",
              paddingBottom: "20px",
            }}
          >
            <div
              className="ecstyles"
              style={{
                cursor: "pointer",
                position: "sticky",
                top: 0,
                zIndex: 400,
                backgroundColor: "#FFF",
                width: "100%",
              }}
              onClick={() => history.push("/Email/accounts")}
            >
              <div style={{ padding: "9px 0px" }}>
                <img loading="lazy" src={coldMailLogo} alt="rocket" />
              </div>
            </div>
            {sidebarItems.map((val, idx) => {
              return (
                <Tooltip title={val.name} arrow placement="right">
                  <div
                    key={idx}
                    onClick={() => {
                      setSelected(idx);
                      setOpen(true);
                      switch (idx) {
                        case 0:
                          return history.push("/Email/accounts");
                        case 1:
                          return history.push("/Lists");
                        case 2:
                          return history.push("/DashBoard/Campaign");
                        case 3:
                          return history.push("/Replies");
                        case 4:
                          return history.push("/All-Campaign/Schedule");
                        case 5:
                          return history.push("/BulkMailVerification");
                        case 6:
                          return history.push("/Goals");
                        case 7:
                          return history.push("/integrations");
                        case 8:
                          return history.push("/Pricing");
                        case 9:
                          return history.push("/Accounts");
                        default:
                          return null;
                      }
                    }}
                    onMouseEnter={() => {
                      setSelected(idx);
                      setOpen(true);
                      if (idx === 0) {
                        setSubSideBarItem(subSideBar2);
                      } else if (idx === 1) {
                        setSubSideBarItem(verifySidebar2);
                      } else if (idx === 2) {
                        setSubSideBarItem(subAccountSidebar2);
                      } else {
                        setSubSideBarItem(warmupOptions2);
                      }
                    }}
                    className={`${
                      defaultActivePathIndex === val.pathIndex
                        ? "mailIcon mailIconActive"
                        : "mailIcon mailIconInActive"
                    }`}
                    style={{ position: "relative" }}
                  >
                    <div
                      className="mailIconContent"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {defaultActivePathIndex === val.pathIndex
                        ? val.activeSvg
                        : val.svg}
                      <span
                        style={{ fontSize: "14px", letterSpacing: "0.8px" }}
                        className="font-semibold"
                      >
                        {val.pathIndex === 1
                          ? val.name.slice(6, val.name.length)
                          : val.name}
                      </span>
                    </div>
                  </div>
                </Tooltip>
              );
            })}
          </div>
        </div>
        {/* right side content */}
        <div style={{ height: "100vh", width: "100%" }}>
          <div className="navbarDashboard">
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <BreadCrumbs />
            </div>

            <div className="profilephotolayout">
              {/* <button
                style={{
                  backgroundColor: "#D1DFE9",
                  color: "#1C485F",
                  padding: "4px 20px",
                  borderRadius: 4,
                  fontSize: "14px",
                  fontWeight: 400,
                  fontFamily: "Source Sans 3",
                }}
                onClick={() => {
                  history.push("/Accounts/spf-generator");
                }}
              >
                SPF Generator
              </button>
              <button
                style={{
                  backgroundColor: "#D1DFE9",
                  color: "#1C485F",
                  padding: "4px 20px",
                  borderRadius: 4,
                  fontSize: "14px",
                  fontWeight: 400,
                  fontFamily: "Source Sans 3",
                }}
                onClick={() => {
                  history.push("/Accounts/dmarc-generator");
                }}
              >
                DMARC Generator
              </button> */}
              <button
                style={{
                  backgroundColor: "#D1DFE9",
                  color: "#1C485F",
                  padding: "4px 20px",
                  borderRadius: 4,
                  fontSize: "14px",
                  fontWeight: 400,
                  fontFamily: "Source Sans 3",
                }}
                onClick={() => {
                  window.open(
                    "https://outlook.office365.com/owa/calendar/ColdSender@coldsender.com/bookings/",
                    "_blank"
                  );
                }}
              >
                Demo
              </button>
              {/* <button
                style={{
                  backgroundColor: "#D1DFE9",
                  color: "#1C485F",
                  padding: "4px 20px",
                  borderRadius: 4,
                  fontSize: "14px",
                  fontWeight: 400,
                  fontFamily: "Source Sans 3",
                }}
                onClick={() => {
                  history.push("/pricing");
                }}
              >
                {currentPlan.plan?.SubscriptionDetails?.Name === "Free"
                  ? "Upgrade"
                  : currentPlan.plan?.SubscriptionDetails?.Name}
              </button> */}
              <div className="usernamelayout">
                <p
                  style={{
                    color: "#4B4B4B",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontFamily: "Source Sans 3",
                  }}
                >
                  {userDetails &&
                    (userDetails.details.Name ||
                      `${userDetails.details.FirstName} ${userDetails.details.LastName}`)}
                </p>
                <p
                  style={{
                    marginTop: "0px",
                    color: "#1C485F",
                    fontSize: "14px",
                    fontWeight: 500,
                    fontFamily: "Source Sans 3",
                  }}
                >
                  {userDetails && userDetails.details.Email}
                </p>
              </div>
              <div>
                <Button
                  id="basic-button"
                  aria-controls={MenuOpen ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={MenuOpen ? "true" : undefined}
                  onClick={handleClick}
                  sx={{
                    outline: "none !important",
                    padding: "0px",
                    "&:hover": {
                      background: "transparent !important",
                    },
                  }}
                  disableRipple
                  disableElevation
                >
                  <Avatar sx={{ bgcolor: "#D1DFE9", color: "#1C485F" }}>
                    {initialsString && initialsString.length >= 2
                      ? initialsString.slice(0, 2).toUpperCase()
                      : initialsString && initialsString.toUpperCase()}
                  </Avatar>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={MenuOpen}
                  onClose={handleCloseFilterMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  sx={{
                    zIndex: 3000,
                    top: 12,
                    paddingBottom: "0px !important",
                    paddingTop: "0px !important",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      padding: "10px 14px",
                      width: "24vw",
                    }}
                  >
                    <button
                      style={{
                        backgroundColor: "#3A974A",
                        outline: "none",
                        borderRadius: "4px",
                        padding: "6px 22px",
                        color: "#FFF",
                      }}
                    >
                      {currentPlan.plan?.SubscriptionDetails.Name}
                    </button>
                    <button
                      style={{
                        backgroundColor: "#648BA4",
                        outline: "none",
                        borderRadius: "4px",
                        padding: "6px 12px",
                        color: "#FFF",
                      }}
                    >
                      {currentPlan.plan?.SubscriptionDetails.Days === 30
                        ? "Monthly"
                        : currentPlan.user?.RedeemCode !== undefined &&
                          currentPlan.user?.RedeemCode.length > 0
                        ? "Lifetime"
                        : "Yearly"}
                    </button>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "6px",
                      padding: "10px 14px",
                      backgroundColor: "#F6F8FD",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "6px",
                          padding: "10px 14px",
                          backgroundColor: "#F6F8FD",
                        }}
                      >
                        <div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginBottom: "5px",
                            }}
                          >
                            <p>Email credits used</p>
                            <p
                              style={{
                                color: "#393939",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontWeight: 400,
                                fontStyle: "normal",
                                marginTop: "0px",
                              }}
                            >
                              {currentPlan.plan?.SubscriptionDetails
                                      ?.EmailLimit===-9999
                                ? "Unlimited"
                                : `${
                                    currentPlan.plan?.SubscriptionDetails
                                      ?.EmailLimit -
                                    currentPlan.plan?.EmailLimit
                                  }/${
                                    currentPlan.plan?.SubscriptionDetails
                                      ?.EmailLimit
                                  }`}
                            </p>
                          </div>
                          <Box sx={{ width: "100%" }}>
                            <LinearProgress
                              variant="determinate"
                              value={
                                ((currentPlan.plan?.SubscriptionDetails
                                  ?.EmailLimit -
                                  currentPlan.plan?.EmailLimit) /
                                  currentPlan.plan?.SubscriptionDetails
                                    ?.EmailLimit) *
                                100
                              }
                              sx={{
                                padding: "4px 0px",
                                borderRadius: "6px",
                                backgroundColor: "#F3F3F3",
                              }}
                            />
                          </Box>
                        </div>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginBottom: "5px",
                            }}
                          >
                            <p
                              style={{
                                color: "#393939",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontWeight: 400,
                                fontStyle: "normal",
                              }}
                            >
                              Unique contacts used
                            </p>
                            <p
                              style={{
                                color: "#393939",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontWeight: 400,
                                fontStyle: "normal",
                                marginTop: "0px",
                              }}
                            >
                              {console.log("contact limeiut",currentPlan.plan?.ContactLimit)}
                              {currentPlan.plan?.SubscriptionDetails
                                      ?.ContactLimit===-9999
                                ? "Unlimited"
                                : `${
                                    currentPlan.plan?.SubscriptionDetails
                                      ?.ContactLimit -
                                    currentPlan.plan?.ContactLimit
                                  }/${
                                    currentPlan.plan?.SubscriptionDetails
                                      ?.ContactLimit
                                  }`}
                            </p>
                          </div>
                          <Box sx={{ width: "100%" }}>
                            <LinearProgress
                              variant="determinate"
                              value={
                                ((currentPlan.plan?.SubscriptionDetails
                                  ?.ContactLimit -
                                  currentPlan.plan?.ContactLimit) /
                                  currentPlan.plan?.SubscriptionDetails
                                    ?.ContactLimit) *
                                100
                              }
                              sx={{
                                padding: "4px 0px",
                                borderRadius: "6px",
                                backgroundColor: "#F3F3F3",
                              }}
                            />
                          </Box>
                        </div>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginBottom: "5px",
                            }}
                          >
                            <p
                              style={{
                                color: "#393939",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontWeight: 400,
                                fontStyle: "normal",
                              }}
                            >
                              Unique Verification used
                            </p>
                            <p
                              style={{
                                color: "#393939",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontWeight: 400,
                                fontStyle: "normal",
                                marginTop: "0px",
                              }}
                            >
                              {currentPlan.plan?.SubscriptionDetails
                                      ?.EmailVerificationLimit===-9999
                                ? "Unlimited"
                                : `${
                                    currentPlan.plan?.SubscriptionDetails
                                      ?.EmailVerificationLimit -
                                    currentPlan.plan?.EmailVerificationLimit
                                  }/${
                                    currentPlan.plan?.SubscriptionDetails
                                      ?.EmailVerificationLimit
                                  }`}
                            </p>
                          </div>
                          <Box sx={{ width: "100%" }}>
                            <LinearProgress
                              variant="determinate"
                              value={
                                ((currentPlan.plan?.SubscriptionDetails
                                  ?.EmailVerificationLimit -
                                  currentPlan.plan?.EmailVerificationLimit) /
                                  currentPlan.plan?.SubscriptionDetails
                                    ?.EmailVerificationLimit) *
                                100
                              }
                              sx={{
                                padding: "4px 0px",
                                borderRadius: "6px",
                                backgroundColor: "#F3F3F3",
                              }}
                            />
                          </Box>
                        </div>
                      </div>
                      <div style={{ margin: "16px 20px" }}>
                        <button
                          onClick={() => {
                            localStorage.removeItem("MailSenderuserDetails");
                            window.location.reload();
                          }}
                          style={{
                            padding: "8px 16px",
                            fontFamily: "Source Sans 3",
                            fontStyle: "normal",
                            fontSize: "12px",
                            color: "#1C485F",
                            display: "flex",
                            gap: "8px",
                            border: "1px solid #1C485F",
                            alignItems: "center",
                            borderRadius: "4px",
                            outline: "none",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M7.41602 6.3002C7.67435 3.3002 9.21602 2.0752 12.591 2.0752H12.6993C16.4243 2.0752 17.916 3.56686 17.916 7.29186V12.7252C17.916 16.4502 16.4243 17.9419 12.6993 17.9419H12.591C9.24102 17.9419 7.69935 16.7335 7.42435 13.7835"
                              stroke="#1C485F"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.5009 10H3.01758"
                              stroke="#1C485F"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M4.87565 7.20801L2.08398 9.99967L4.87565 12.7913"
                              stroke="#1C485F"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          Logout
                        </button>
                      </div>
                    </div>
                  </div>
                </Menu>
              </div>
            </div>
          </div>
          <div
            style={{
              // flexGrow:1,
              height: "calc(100% - 65px)",
              // overflow:'auto',
              // backgroundColor:'skyblue',
              // padding:`${location.pathname === "/All-Campaign/Templates"? "0px":"6px"} 16px ${location.pathname === "/All-Campaign/Templates"? "0px":"6px"} ${location.pathname === "/MailWarmUp"||location.pathname === "/All-Campaign/New-Campaign" || location.pathname === "/All-Campaign/Templates"? "0px":"16px"}`}}
              padding: `${
                location.pathname === "/Pricing" ||
                location.pathname === "/pricing" ||
                location.pathname.includes("/MailWarmUp") ||
                location.pathname === "/All-Campaign/New-Campaign"
                  ? "0px 0px"
                  : "14px 12px"
              }`,
            }}
          >
            <Componant setOpen3={setOpen3} />
          </div>
          <style>
            {`
                .css-6hp17o-MuiList-root-MuiMenu-list{
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                }
            `}
          </style>
        </div>

        {/* {open && (
          <div
            // ref={divRef}
            className="sidebaropenContent"
            style={{ height: "100vh",zIndex:300}}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
          >
            <div
              className="sidebaropenItems"
              style={{ borderBottom: "1px solid #DDDDDD" }}
            >
              <h1
                style={{
                  lineHeight: "20px",
                  fontFamily: "Source Sans 3",
                  color: "#727272",
                  fontSize: "16px",
                  fontWeight: 700,
                  fontStyle: "normal",
                }}
              >
                {sidbarTitles[selected]}
              </h1>
            </div>
            {subSideBarItem.map((val, idx) => {
              return (
                <div key={idx}
                  onClick={() => {
                    setSelectedSub(idx);
                    console.log("Selected",idx)
                    if (selected === 0) {
                      if (idx === 0) {
                        history.push("/DashBoard/Campaign");
                      } 
                      else if (idx === 1) {
                        history.push("/All-Campaign/New-Campaign");
                      }
                      else if (idx === 2) {
                        history.push("/All-Campaign/Templates");
                      }
                      else{
                        history.push("/All-Campaign/Schedule");
                      }
                      // else
                      // if(idx===1){
                      //   setOpen3(true)
                      // }
                      // else
                      // if(idx===2){
                      //   history.push('/All-Campaign/New-Campaign')
                      // }
                    } else if (selected === 1) {
                        if (idx === 0) {
                          history.push("/Emailverify");
                        } else {
                          history.push("/BulkMailVerification");
                        }
                      // if (idx === 0) {
                      //   history.push("/Contacts");
                      // } else if (idx === 1) {
                      //   history.push("/Contacts/Import-options");
                      // }
                    }
                    if (selected === 2) {
                      if (idx === 0) {
                        history.push("/Contacts");
                      } else {
                        history.push("/Lists");
                      }
                    }
                    if (selected === 3) {
                      if (idx === 0) {
                        history.push("/AllMailWarmUp");
                      } else {
                        history.push("/MailWarmUp");
                      }
                    }
                    setOpen(false);
                  }}
                  className={`sidebaropenItems ${
                    location.pathname === val.path ? "sidebaropenItemActive" : "sidebaropenItemInActive"
                    }`}
                >
                  <p>{location.pathname === val.path}</p>
                  {val.value}
                </div>
              );
            })}
          </div>
        )} */}
      </div>
      <Modal
        open={open2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          className="modalPopupDelete"
          style={{
            width: "90vw",
            left: "5%",
            top: "2%",
            overflowY: "scroll",
            height: "96vh",
          }}
        >
          <Pricing />
        </div>
      </Modal>
    </>
  );
}
